import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=cda25a92&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"
import style0 from "./Exam.vue?vue&type=style&index=0&id=cda25a92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda25a92",
  null
  
)

export default component.exports